import React from "react";
import Wprr from "wprr";
import FaqQuestion from "./FaqQuestion";

export default class Faq extends Wprr.BaseObject {
    _construct() {
        super._construct();

        this._elementTreeItem.requireValue("questions", []);
    }

    _renderMainElement() {
        let questions = this.getFirstInputWithDefault(Wprr.sourceReference("blockData", "questions"), [])
        return <div className="centered-content-text">
            {questions.map((question, index) => {
                if (index === this.getFirstInput.length - 1) {
                    return (
                        <div key={index}>
                            <FaqQuestion question={question.question} answer={question.answer} />
                        </div>
                    );
                } else {
                    return (
                        <div key={index}>
                            <FaqQuestion question={question.question} answer={question.answer} />
                            <div className="spacing medium" />
                        </div>
                    );
                }
            })}
        </div>;
    }

    static getWpAdminEditor() {
        console.log("getWpAdminEditor");

        let dataSettings = {};

        let newItemTemplate = {
            question: "",
            icon: "",
            answer: "",
        };

        let itemMarkup = (
            <div>
                <Wprr.layout.form.LabelledArea label="Question">
                    <Wprr.EditableProps
                        editableProps={Wprr.source("combine", ["questions.", Wprr.sourceReference("loop/array/index"), ".question"])}
                        externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")}
                    >
                        <Wprr.FormField
                            className="full-width"
                            valueName={Wprr.source("combine", ["questions.", Wprr.sourceReference("loop/array/index"), ".question"])}
                            placeholder={Wprr.sourceTranslation("Question")}
                        />
                    </Wprr.EditableProps>
                </Wprr.layout.form.LabelledArea>

                <div className="spacing small" />

                <Wprr.layout.form.LabelledArea label="Answer">
                    <Wprr.EditableProps
                        editableProps={Wprr.source("combine", ["questions.", Wprr.sourceReference("loop/array/index"), ".answer"])}
                        externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")}
                    >
                        <Wprr.wp.blocks.editor.RichTextEditor
                            className="full-width"
                            valueName={Wprr.source("combine", ["questions.", Wprr.sourceReference("loop/array/index"), ".answer"])}
                            placeholder={Wprr.sourceTranslation("Text")}
                        />
                    </Wprr.EditableProps>
                </Wprr.layout.form.LabelledArea>
            </div>
        );

        let spaceMarkup = <div className="spacing small" />;

        return React.createElement(
            Wprr.layout.admin.WpBlockEditor,
            { dataSettings: dataSettings },
            <div>
                <label>{Wprr.translateText("Questions")}</label>
                <Wprr.EditableProps editableProps="questions" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")}>
                    <Wprr.ArrayEditor valueName="questions" newItemTemplate={newItemTemplate} editItemMarkup={itemMarkup} loopItemSpacingMarkup={spaceMarkup} />
                </Wprr.EditableProps>
            </div>
        );
    }
}
